import { render, staticRenderFns } from "./BusinessProfileCdcForm.vue?vue&type=template&id=2c0086fd&scoped=true&"
import script from "./BusinessProfileCdcForm.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileCdcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0086fd",
  null
  
)

export default component.exports